import React from 'react';
import NotificationBell from './NotificationBell';
import ThemeSwitcher from './ThemeSwitcher';
import ViewModeSwitcher from '../ViewModeSwitcher';

const Header = ({ onMenuClick }) => {
  let user = null;
  try {
    const stored = localStorage.getItem('user');
    if (stored) user = JSON.parse(stored);
  } catch (e) {
    user = null;
  }

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : 'U';

  const roleLabel =
    {
      super_admin: 'Super Admin',
      admin: 'Admin',
      teacher: 'Professeur',
      principal_teacher: 'Prof. Principal',
      student: 'Élève',
      parent: 'Parent',
    }[user?.role] || 'Utilisateur';

  return (
    <header className="h-20 bg-white border-b border-gray-100 flex items-center justify-between px-3 md:px-8 gap-2 md:gap-3 sticky top-0 z-40 flex-shrink-0">

      {/* ☰ Bouton hamburger — visible uniquement sur mobile */}
      <button
        type="button"
        onClick={onMenuClick}
        className="md:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-700 flex-shrink-0"
        aria-label="Ouvrir le menu"
      >
        <MenuIcon className="w-6 h-6" />
      </button>

      {/* Barre de recherche — cachée sur très petit écran */}
      <div className="flex-1 max-w-md hidden sm:block">
        <div className="relative">
          <span className="absolute top-1/2 -translate-y-1/2 left-4 text-gray-400">
            <SearchIcon className="w-5 h-5" />
          </span>
          <input
            type="text"
            placeholder="Rechercher une fonctionnalité..."
            className="w-full bg-gray-50 border border-gray-200 rounded-full pl-12 pr-4 py-3 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-[#F39C12] focus:bg-white transition"
          />
        </div>
      </div>

      {/* Droite : mode d'affichage + thème + notifications + user */}
      <div className="flex items-center gap-1.5 md:gap-4 ml-auto">

        {/* 🖥️ Sélecteur de mode Téléphone / Ordinateur (Caché sur mobile) */}
        <div className="hidden md:block">
          <ViewModeSwitcher />
        </div>

        {/* 🎨 Sélecteur de thème */}
        <ThemeSwitcher />

        {/* 🔔 Cloche de notifications dynamique */}
        <NotificationBell />

        {/* Profil utilisateur */}
        <div className="flex items-center gap-2 md:gap-3 bg-gray-50 rounded-full pl-1.5 md:pl-2 pr-2 md:pr-4 py-1.5 ml-1">
          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#F39C12] flex items-center justify-center text-white font-bold text-xs md:text-sm">
            {initials}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-bold text-[#0A0A0A] leading-tight">
              {user?.name || 'Utilisateur'}
            </p>
            <p className="text-xs text-gray-500">{roleLabel}</p>
          </div>
          <ChevronDownIcon className="w-4 h-4 text-gray-400 hidden md:block" />
        </div>
      </div>
    </header>
  );
};

// ═══════════ ICÔNES SVG ═══════════
const SearchIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ChevronDownIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const MenuIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export default Header;